<template lang="pug">
.settings
  HScroll(:currentStep='currentStep')
    transition(name='simple-fade' mode='out-in')
      //- STEP 1 (action selector)
      ActionSelectorMenu(:items='actionItems' v-model='actionType')

    transition(name='simple-fade' mode='out-in')
      //- STEP 2 (visible if actionType is selected)
      div(v-if='actionType')
        template(v-if='actionType === "EDIT_PERSONAL_INFO"')
          EditPersonalInfoPanel
        //- template(v-else-if='actionType === "LINE_API"')
        //-   LineApiPanel

</template>

<script>
import EditPersonalInfoPanel from '@/components/settings/panels/EditPersonalInfoPanel.vue';
// import LineApiPanel from '@/components/settings/panels/LineApiPanel.vue';

export default {
  data: () => ({
    customer: null,
    actionType: null,
    currentStep: 0,

    STEP_SELECT_ACTION: 1,
    // STEP_PERFORM_ACTION: 3,

    actionItems: {
      EDIT_PERSONAL_INFO: 'แก้ไขข้อมูลส่วนตัว',
      // LINE_API: 'เชื่อมต่อ LINE',
    },
  }),
  watch: {
    actionType(newVal) {
      if (newVal) {
        this.setCurrentStep(this.STEP_SELECT_ACTION);
      }
    },
  },
  methods: {
    setCurrentStep(step) {
      // change step to step - 1 => wait 50ms => change step to the actual value
      // so the change is always noticed by the HSrcoll component
      // HSroll will then scoll to the right, so the new view is visible to the user
      this.currentStep = step - 1;
      setTimeout(() => {
        this.currentStep = step;

        //
        // 1. PREPARE the data for each STEP
        // 2. RESET the data gathered from further steps
        //    so the data won't be mixed up
        //

        // STEP 1
        if (step < this.STEP_SELECT_ACTION) {
          this.actionType = null;
        }
      }, 50);
    },
  },
  components: {
    EditPersonalInfoPanel,
    // LineApiPanel,
  },
};
</script>

<style lang="scss">
.settings {
  > .h-scroll {
    height: 100%;
  }
}
</style>
